import React from 'react';
import { semantic } from '@lexody/design-tokens';

const VARIANT_COLORS = {
  primary: semantic.primary.surface.default,
  white: semantic.greyscale.text.negative,
  subtle: semantic.greyscale.text.subtitle,
};

/**
 * CSS ring spinner — replaces legacy loader.gif usage.
 *
 * @param {number} size — diameter in px
 * @param {'primary'|'white'|'subtle'} variant
 * @param {string} [color] — override stroke color
 */
const LoadingSpinner = ({
  size = 32,
  variant = 'primary',
  color,
  className = '',
  label = 'Loading',
}) => {
  const strokeColor = color || VARIANT_COLORS[variant] || VARIANT_COLORS.primary;
  const borderWidth = Math.max(2, Math.round(size / 11));

  return (
    <span
      className={`lex-spinner ${className}`.trim()}
      role="status"
      aria-label={label}
      style={{
        width: size,
        height: size,
        borderWidth,
        borderColor: `${strokeColor}26`,
        borderTopColor: strokeColor,
      }}
    />
  );
};

export default LoadingSpinner;
